import { render } from "./TimelineBody.vue?vue&type=template&id=6a39c50a&scoped=true"
import script from "./TimelineBody.vue?vue&type=script&lang=js"
export * from "./TimelineBody.vue?vue&type=script&lang=js"

import "./TimelineBody.vue?vue&type=style&index=0&id=6a39c50a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a39c50a"]])

export default __exports__